<template>
  <AutoCompleteGroup
    :name="name"
    :label="label"
    option-label="description"
    :suggestions="addressSuggestions"
    v-bind="$attrs"
    @item-select="handleAddressSelect"
    @complete="getPlacePredictions($event)"
  />
</template>

<script setup>
import { ref } from 'vue';
import AutoCompleteGroup from '@/components/forms/groups/AutoCompleteGroup.vue';

defineProps({
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['addressSelected', 'error']);

const addressSuggestions = ref([]);

const getPlacePredictions = async ({ query }) => {
  if (!query || !window.google) {
    addressSuggestions.value = [];
    return;
  }

  try {
    const { suggestions } =
      await window.google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(
        {
          input: query,
          includedPrimaryTypes: ['geocode'],
        },
      );

    addressSuggestions.value = suggestions.map((suggestion) => ({
      description: suggestion.placePrediction.text.text,
      place_id: suggestion.placePrediction.placeId,
    }));
  } catch (error) {
    addressSuggestions.value = [];
    emit('error', error);
  }
};

const handleAddressSelect = async (event) => {
  const placeId = event.value.place_id;

  try {
    const place = new window.google.maps.places.Place({
      id: placeId,
    });

    await place.fetchFields({
      fields: ['addressComponents', 'formattedAddress', 'location', 'types'],
    });

    const placeDetails = {
      place_id: placeId,
      formatted_address: place.formattedAddress,
      address_components: place.addressComponents,
      geometry: {
        location: place.location,
      },
      types: place.types,
    };

    emit('addressSelected', placeDetails);
  } catch (error) {
    addressSuggestions.value = [];
    emit('error', error);
  }
};
</script>
